export const showHideSearch = (showSearch) =>{
    return dispatch => {
        dispatch({ type: 'SHOW_HIDE_SEARCH', showSearch });
    }
}